import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

// Models
import { ApiResponse } from '../shared/models/api-response.model';
import { ItemVariation } from 'src/shared/models/item-variation.model';
import { ChildSale, ChildSaleResponse, BulkChildSale, BulkChildSaleResponse } from 'src/shared/models/child-sale.model';

@Injectable({
  providedIn: 'root',
})
export class ChildSaleService {
  constructor(public httpClient: HttpClient) {}

  protected static getIndexUri(url: string): string {
    return environment.apiUrl + url;
  }

  protected static createIndexuri(): string {
    return environment.apiUrl + 'v3/commerce/clare/orders/create_child_order';
  }

  private static getOptions(params?: object): object {
    return {
      params: params,
      withCredentials: true,
      headers: {
        Accept: 'application/json',
      },
    };
  }

  public getSaleItems(
    organization_id: string,
    page: number,
    per_page: number,
    searchTerm: string,
    addons: boolean
  ): Observable<ApiResponse<ItemVariation[]>> {
    let params;
    if (searchTerm) {
      params = {
        membership: 'false',
        'order[name]': 'asc',
        organization_id: organization_id,
        page: page.toString(),
        per_page: per_page.toString(),
        search_fields: 'full_name',
        search_term: searchTerm,
        addons: addons,
      };
    } else {
      params = {
        membership: 'false',
        'order[name]': 'asc',
        organization_id: organization_id,
        page: page.toString(),
        per_page: per_page.toString(),
        addons: addons,
      };
    }
    return this.httpClient.get<ApiResponse<any>>(
      ChildSaleService.getIndexUri('finance/item_variations'),
      ChildSaleService.getOptions(params)
    );
  }

  public getCreditReasons(organization_id: string): Observable<ApiResponse<{ id: number; title: string }[]>> {
    return this.httpClient.get<ApiResponse<{ id: number; title: string }[]>>(
      environment.apiUrl + 'v3/commerce/clare/tenants/' + organization_id + '/credit_reasons',
      ChildSaleService.getOptions()
    );
  }

  public getOrder(orderId: number): Observable<ApiResponse<Record<string, unknown>>> {
    return this.httpClient.get<ApiResponse<Record<string, unknown>>>(
      ChildSaleService.getIndexUri('commerce/orders/' + orderId),
      ChildSaleService.getOptions()
    );
  }

  public createOrder(childSale: ChildSale): Observable<ApiResponse<ChildSaleResponse>> {
    return this.httpClient.post<ApiResponse<ChildSaleResponse>>(
      ChildSaleService.getIndexUri('v3/commerce/clare/orders/create_child_order'),
      childSale,
      ChildSaleService.getOptions()
    );
  }

  public createBulkOrders(bulkChildSale: BulkChildSale): Observable<ApiResponse<BulkChildSaleResponse>> {
    return this.httpClient.post<ApiResponse<BulkChildSaleResponse>>(
      ChildSaleService.getIndexUri('v3/commerce/clare/orders/create_bulk_child_orders'),
      bulkChildSale,
      ChildSaleService.getOptions()
    );
  }
}
